import { render, staticRenderFns } from "./ProfileVlastPrivacyPolicy.vue?vue&type=template&id=17b3ca41"
import script from "./ProfileVlastPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./ProfileVlastPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports